import { useMemo } from 'react'
import { type ReportFilterDefinitionsInterface, ReportFilterTypeEnum } from '__codegen__/api'
import { useDashIntl } from 'intl/intl.hooks'
import { useReportList } from 'legacy/sections/generated-reports/graphql/reportList.hook'
import { slugToIntlKey } from 'legacy/sections/generated-reports/components/list/utils/generatedReports.utils'

export type GeneratedReportsAddFilters = {
  [key: string]: ReportFilterDefinitionsInterface[]
}

export const useGeneratedReportsAddBehaviour = () => {
  const intl = useDashIntl()
  const { reports, loading, error } = useReportList()

  const datasetOptions = useMemo(() => {
    if (!reports) return []

    return reports.map(report => ({
      label: intl.formatMessage({ id: slugToIntlKey(report.slug) }),
      value: report.id,
    }))
  }, [intl, reports])

  const filterOptions = useMemo(() => {
    const filters: GeneratedReportsAddFilters = {}

    reports.forEach(({ id, supportedFilters }) => {
      filters[id] = supportedFilters
    })

    return filters
  }, [reports])

  return {
    datasetOptions,
    filterOptions,
    loading,
    error,
  }
}

export type UseGeneratedReportsAddBehaviour = ReturnType<typeof useGeneratedReportsAddBehaviour>
